@if ($showMenu()) {
    <div class="cm-container">
        <ng-content select="[cm-action-menu-additional]"></ng-content>
        @if ($pendingTasksDescriptor(); as pendingTasksDescriptor) {
            <a class="cm-icon-container" [matTooltip]="pendingTasksDescriptor">
                <cm-loading-spinner-icon class="cm-mini-spinner"></cm-loading-spinner-icon>
            </a>
        }
        @if ($enableDimensionGuides()) {
            <a
                class="cm-icon-container"
                [ngClass]="{'cm-icon-selected': $dimensionGuidesActive()}"
                (click)="toggleDimensionGuides()"
                tp="Show Dimensions"
                [tpAppendTo]="tooltipContainer"
            >
                <i class="far far fa-ruler"></i>
            </a>
        }
        @if ($pdfEnabled()) {
            <a class="cm-icon-container" (click)="downloadPdf()" tp="Download PDF" [tpAppendTo]="tooltipContainer">
                <i class="far fa-file-pdf"></i>
            </a>
        }
        @if ($stlDownloadEnabled()) {
            <cm-template-scene-provider (onInitialized)="setSceneManagerService($event)">
                <a class="cm-icon-container" (click)="exportStlClicked()" tp="Download STL" [tpAppendTo]="tooltipContainer">
                    <i class="far fa-arrow-to-bottom"></i> </a
            ></cm-template-scene-provider>
        }
        @if ($gltfDownloadEnabled()) {
            <cm-template-scene-provider (onInitialized)="setSceneManagerService($event)">
                <cm-three-template-scene-provider (onInitialized)="setThreeSceneManagerService($event)">
                    <a class="cm-icon-container" (click)="exportGltfClicked()" tp="Download glTF" [tpAppendTo]="tooltipContainer">
                        <i class="far fa-arrow-to-bottom"></i> </a
                ></cm-three-template-scene-provider>
            </cm-template-scene-provider>
        }
        @if ($snapshotEnabled()) {
            <a class="cm-icon-container" (click)="actionMenuService.captureSnapshot()" tp="Capture snapshot" [tpAppendTo]="tooltipContainer">
                <i class="far fa-camera"></i>
            </a>
        }
        @if ($fullscreenAvailable()) {
            <a
                class="cm-icon-container"
                (click)="toggleFullscreen()"
                [tp]="$inFullscreen() ? 'Exit full screen' : 'Full screen'"
                [tpAppendTo]="tooltipContainer"
            >
                <i [ngClass]="$inFullscreen() ? 'far fa-compress' : 'far fa-expand'"></i>
            </a>
        }
        @if ($arEnabled()) {
            <a class="cm-icon-container" (click)="viewInArClicked()" tp="View in AR" [tpAppendTo]="tooltipContainer">
                <i class="far fa-cube"></i>
                <span class="cm-ar-icon-text"> AR </span>
                <div
                    [tp]="arDialog"
                    tpVariation="popper"
                    [tpAppendTo]="tooltipContainer"
                    [tpHideOnClick]="false"
                    [tpIsVisible]="$desktopArUrl() !== undefined"
                    [tpOffset]="$tpOffset()"
                ></div>
                <ng-template #arDialog let-hide>
                    <cm-ar-dialog (close)="$desktopArUrl.set(undefined)" [desktopArUrl]="$desktopArUrl()"></cm-ar-dialog>
                </ng-template>
            </a>
        }
    </div>
    <div class="tooltip-container" #tooltipContainer></div>
}
